<template>
  <div
    class="createTender"
    :class="{'two-column': isTwoColumn, 'is-min': mini}">
    <div
      class="createTender_left">
      <div
        class="createTender_breadcrumbs">
        <Breadcrumbs
          :disabled="loading.blockSteps"
          :items="breadcrumbs"/>
        <TenderTopActions
          v-if="tender && tender.tenderId"
          :tender="tender"/>
      </div>
      <sIcon
        v-if="loading.initial || !steps[currentStep - 1]"
        class="align-self-center my-3 mx-auto"
        color="var(--white-color)"
        size="30"
        spin
        type="loading"/>
      <sForm
        v-else-if="steps[currentStep - 1]"
        id="content-container"
        ref="tenderForm"
        class="createTender_content"
        :disabled="loading.save"
        label-position="top"
        label-width="100px"
        :model="mixin_formData"
        :rules="stepRules">
        <CollapseBlock
          v-if="isDeveloper"
          transparent
          :value.sync="showDevInfo">
          <div
            slot="title">
            Службова інформація
          </div>
          <div>
            <div>isGroupLotsEnabled: {{ isGroupLotsEnabled }} </div>
          </div>
        </CollapseBlock>
        <component
          v-if="componentMain"
          :is="componentMain.component"
          ref="component"
          v-bind="componentMain.options"
          v-on="componentMain.handlers">
          <template
            v-if="currentStepProps && currentStepProps.component !== 'TenderCheck'"
            #title>
            <div
              class="createTender_title">
              {{ $t(`Tenders.CreateStep.${currentStepProps.text}.Name`) }}
            </div>
            <div
              class="createTender_description">
              {{ $t(`Tenders.CreateStep.${currentStepProps.text}.Description`) }}
            </div>
          </template>
        </component>
      </sForm>
    </div>
    <component
      v-if="componentInfo && componentInfo.options && componentInfo.options.tenderId"
      :is="componentInfo.component"
      v-bind="componentInfo.options"
      class="createTender_right"
      v-on="componentInfo.handlers"/>

    <CreateItemFooter
      :options="{
        currentStep: currentStep,
        back: {
          disabled: loading.blockSteps || loading.initial || currentStep === 1,
        },
        steps: {
          show: true,
          items: steps,
          disabled: loading.blockSteps || !mixin_tenderId || loading.initial,
          loading: loading.initial,
        },
        next: {
          show: currentStep !== steps.length,
          disabled: loading.blockSteps || loading.initial || currentStep === steps.length,
        },
      }"
      :style="isTwoColumn ? 'grid-column: 1 / -1;' : ''"
      @back-step="backStep()"
      @click-step="changeStepWithModal($event)"
      @next-step="changeSteps(currentStep + 1)"/>
  </div>
</template>
<script>
/**
 * Создание/изменение тендера по новому дизайну и списку шагов
 * customCheckChange - методы проверки изменений для конкретного шага. Кастомные поля или поля вне объекта тендера. Возвращает true/false
 * beforeNextStep - выполняется до отправки данных на бек
 * afterSendTender - выполняется после отправки на бек. В качестве параметра получает объект тендера
 * beforeSendTender - метод конвертации объекта тендера для конкретного шага. Вызывается до отправки (не забываем вызывать его на beforeDestroy)
 */

import TenderSteps from 'components/tenderCreation/TenderSteps.vue'
import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'

import YoucontrolStep from 'components/tenderCreation/Youcontrol.vue'
import TenderInformation from 'components/tenderCreation/TenderInformation.vue'
import TenderLots from 'components/tenderCreation/TenderLots.vue'
import TenderCriteria from 'components/tenderCreation/TenderCriteria.vue'
import TenderCommercialDocumentAndOffer from 'components/tenderCreation/TenderCommercialDocumentAndOffer.vue'
import TenderMembers from 'components/tenderCreation/TenderMembers.vue'
import TenderCheck from 'components/tenderCreation/TenderCheck.vue'
import CreateItemFooter from 'components/common/CreateItemFooter.vue'

import TenderMembersInfo from 'components/tenderCreation/TenderMembersInfo.vue'
import TenderInfoPanel from 'components/tenders/tender page/TenderInfoPanel.vue'

import TenderTopActions from 'components/tenders/TenderTopActions.vue'

import { mapGetters } from 'vuex'
import { debounce } from 'toolkit/utils/util'
import flouProps from 'plugins/tenderFlou.js'

import editTenderMixin from 'mixins/editTenderMixin.js'
import { storageMixin } from 'mixins'
import functionMixin from 'mixins/functionMixin'
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

import Schema from 'async-validator'

import { getCombinedRules, getAdditionalFieldTenderRules, getAdditionalFieldLotsRules } from 'components/tenderCreation/rules.js'
import { eventBus } from '@/main'

const api = new SmarttenderApi()

export default {
  name: 'newTender',
  mixins: [editTenderMixin, functionMixin, storageMixin],
  data() {
    return {
      flou: 'newDesignDefault_default', // логика шагов
      youcontrolEmails: [],
      tender: {}, //  модель тендера
      tenderInfo: {},
      info: {},
      mini: false,
      showDevInfo: true,
      stepRules: {},
      accesNextStep: false, // костыль, что б можно было уйти на следующие шаги, при отсутсвии карты критериев
      loading: {
        initial: true,
        save: false,
        blockSteps: false
      },
      canEdit: true,

      notice: null,
    }
  },
  methods: {
    /**
     * Приглашаем контактов из YC.Market
     */
    async invitedYouControl() {
      if (!this.youcontrolEmails?.length) {
        return
      }
      await api.addInvitedParticipant({
        tenderId: this.tender.tenderId,
        invitedUsers: this.youcontrolEmails?.map(item => ({
          email: item,
          contactId: 0,
          organizationId: 0,
          manualAdded: true
        }))
      }).then(({ rejected, warnings, errors }) => {
        if (errors.length) {
          this.$log_error(errors[0].message)
        }
        this.$_notifyEmailRejections(rejected, warnings)
      }).finally(() => {
        this.$_savePropToLocalStorage('youcontrolTender', null, true)
      })
    },
    /**
     * проверяем наличие сохраненных контактов из YC.Market
     */
    checkYouControl(isNew) {
      const compains = JSON.parse(this.$_getPropFromLocalStorage('youcontrolTender', '[]', true) || '[]')
      if (!compains?.length) {
        return
      }

      if (isNew) {
        this.$set(this, 'youcontrolEmails', compains?.map(i => i.email))
        this.invitedYouControl()
      } else {
        const that = this
        let content = '<ul class="ml-5">'
        compains.forEach((compain) => {
          content += `<li>${compain.email}</li>`
        })
        content += '</ul>'
        this.$Modal.confirm({
          title: 'YC.Market',
          content:
            `${compains.length === 1 ? this.$t('Tenders.foundYCContact') : this.$t('Tenders.foundYCContacts')} від YC.Market</br>
            <b>${this.$t('Tenders.Invite')} ${compains.length === 1 ? this.$t('Tenders.its') : this.$t('Tenders.its')} ${this.$t('Tenders.toTender')}?</b></br>${content}`,
          closable: true,
          okText: this.$t('Tenders.Yes'),
          cancelText: this.$t('Tenders.No'),
          dangerouslyUseHTMLString: true,
          onOk: () => {
            that.$set(that, 'youcontrolEmails', compains?.map(i => i.email) || [])
            this.invitedYouControl()
          },
          onCancel: () => {
            that.$_savePropToLocalStorage('youcontrolTender', null, true)
          },
        })
      }
    },
    createAdditionalFieldRule({value, exist, tender = true}) {
      if (Object.keys(this.stepRules || {}).length) {
        if (tender) {
          const keyRule = exist ? 'existing_fields' : 'additional_fields'
          for (const key in this.stepRules) {
            if (key.startsWith(keyRule)) {
              delete this.stepRules[key]
            }
          }
        }
      }
      if (!value?.length) {
        return
      }
      let newRules = {}
      if (tender) {
        value?.forEach((fieldItem) => {
          newRules = {...newRules, ...getAdditionalFieldTenderRules(this, fieldItem, exist)}
        })
      } else {
        for (const key in this.stepRules) {
          if (key.includes('].additional_fields.')) {
            delete this.stepRules[key]
          }
        }

        if (typeof value === 'object' && !Array.isArray(value)) {
          newRules = {...newRules, ...getAdditionalFieldLotsRules(this, value), ...getCombinedRules(this, ['TenderLots'])}
        } else if (Array.isArray(value)) {
          value.forEach((valueItem) => {
            newRules = {...newRules, ...getAdditionalFieldLotsRules(this, valueItem), ...getCombinedRules(this, ['TenderLots'])}
          })
        }
      }
      this.changeRules(newRules)
    },
    changeRules(rules) {
      const newRules = {...this.$_.cloneDeep(this.stepRules), ...rules}
      this.$set(this, 'stepRules', newRules)

      this.clearValidate()
    },
    clearValidate() {
      this.$emit('clearValidate')

      this.$nextTick(() => {
        this.$refs.tenderForm?.clearValidate()
      })
    },
    validateForm() {
      this.$refs.tenderForm.validate(async () => {})
    },
    async validateObject() {
      const schema = new Schema(this.stepRules)

      await schema.validate(this.mixin_formData, (errors) => {
        let errorsText = ''
        this.$store.dispatch('editTenderStore/setFieldErrors', {values: {}})
        if (!errors?.length) {
          return
        }
        const fieldErrors = {}

        if (this.$refs.component?.checkAndShowCollapse) {
          this.$refs.component?.checkAndShowCollapse(errors)
        }

        errors.forEach((errorItem) => {
          fieldErrors[errorItem.field] = errorItem.message
          errorsText += errorItem.message + '</br>'
        })
        this.$store.dispatch('editTenderStore/setFieldErrors', {values: fieldErrors})
        if (errorsText?.length) {
          this.$notice.warning({
            title: this.$t('Common.ErrorTitle'),
            message: errorsText,
            dangerouslyUseHTMLString: true,
            duration: 10,
            progress: true,
          })
        }
      })
    },
    /**
     * Вызывается из подалки проверки изменений по кнопке игнорировать
     */
    ignoreChange(props) {
      this.$root.$emit('cancelTenderChange')
      this.tender = this.$_.cloneDeep(this.mixin_originTender)
      this.changeSteps(props.stepNumber)
    },
    /**
     * Вызывается из шага с критериями
     */
    setAccessNextStep(props) {
      this.accesNextStep = true
      this.changeSteps(...Object.values(props))
    },
    /**
     * Проверяем изменения и если есть выдаем модалку
     */
    async getChangeProps() {
      if (this.componentMain?.component === 'TenderCheck') {
        return []
      }
      if (this.$refs?.component?.customCheckChange && this.$refs?.component?.customCheckChange()) {
        return true
      }

      let oldTender = await this.mixin_getCheckChangeObject(this.mixin_originTender)
      let newTender = await this.mixin_getCheckChangeObject(this.tender)

      let changeFields = await this.$_compareObjects(newTender, oldTender)
      changeFields = changeFields.filter(fieldPath => !fieldPath.includes('.additional_fields.', '__typename'))
      return changeFields
    },
    async changeStepWithModal(newStepNumber) {
      const changeFields = await this.getChangeProps()
      const hasChange = changeFields?.length !== 0
      if (hasChange) {
        this.$root.$emit('showExitConfirmation', { stepNumber: newStepNumber })
      } else {
        this.changeSteps(newStepNumber)
      }
    },
    async execAfterSendTender(tender) {
      if (this.$refs?.component?.afterSendTender) {
        await this.$refs?.component?.afterSendTender(tender)
      }
    },
    /**
     * Валідація перед переходом на наступний крок
     */
    async $_validateBeforeNextStep(newStepNumber) {
      if (newStepNumber === this.currentStep + 1) {
        try {
          await this.validateObject()
          return { isError: false }
        } catch (error) {
          this.$spinner.close()
          return { isError: true }
        }
      }
      return { isError: false }
    },

    /**
     * Перевірка валідності номера кроку
     */
    $_validateStepNumber(newStepNumber) {
      if (newStepNumber < 1 || newStepNumber > this.info?.steps?.length + 1) {
        this.changeSteps(1, true)
        return false
      }
      return true
    },

    /**
     * Перевірка доступу до переходу на наступний крок
     */
    $_checkStepAccess(newStepNumber, prepare) {
      if (!this.componentMain.needChange) {
        return true
      }
      
      if (!this.accesNextStep && this.$refs?.component?.beforeNextStep) {
        const canProceed = this.$refs.component.beforeNextStep({ newStepNumber, prepare })
        if (!canProceed) {
          this.$spinner.close()
          this.accesNextStep = false
          return false
        }
      }
      
      return true
    },

    /**
     * Збереження тендера при наявності змін
     */
    async $_saveTenderChanges(isNewTender, isError) {
      return new Promise(async (resolve, reject) => {
        if (isError) {
          try {
            await this.$refs.tenderForm.validate()
          } catch (error) {
            this.$spinner.close()
            reject(error)
            return
          }
        }

        await this.mixin_prepareTenderToSave(this.tender, this.$refs?.component?.beforeSendTender)

        try {
          const validationResult = await this.$refs.tenderForm.validate()
          
          if (!validationResult) {
            reject(new Error('Validation failed'))
            return
          }

          const savedTender = await this.$_executeTenderSave(isNewTender)
          await this.$_updateRouterForNewTender(savedTender)
          resolve(savedTender)

        } catch (error) {
          reject(error)
        }
      })
    },

    /**
     * Виконання збереження тендера
     */
    async $_executeTenderSave(isNewTender) {
      const methodChangeTender = isNewTender ? this.mixin_createTender : this.mixin_changeTender
      
      try {
        const tender = await methodChangeTender(this.tender)
        await this.mixin_setAdditionalFieldsToLots(tender.lots)
        return tender
      } catch (error) {
        eventBus.$emit('showErrorSnackbar', error)
        throw error
      }
    },

    /**
     * Оновлення роутера для нового тендера
     */
    async $_updateRouterForNewTender(tender) {
      if (tender?.tenderId) {
        this.$router.replace({
          name: 'editTender', 
          query: { ...this.$route.query, id: tender.tenderId }
        }, () => {}, () => {}, { force: true })
      }
    },

    /**
     * Застосування результатів зміни кроку
     */
    async $_applyStepChanges(tender, newStepNumber, isStepNext, isNewTender) {
      if (isStepNext) {
        await this.execAfterSendTender(tender)
      }
      
      if (isStepNext && !tender) {
        return
      }

      this.$_initializeLotGroups(tender, true)
      this.$_updateTenderData(tender)
      this.$_updateStepState(newStepNumber)
      await this.$_updateRouterAndInfo(tender, newStepNumber, isNewTender)
    },

    /**
     * Оновлення даних тендера
     */
    $_updateTenderData(tender) {
      tender.lots = tender.lots?.length ? tender.lots.filter(item => item.lotId !== 0) : []
      
      if (tender) {
        this.$set(this, 'tender', tender)
      }

      this.$store.dispatch('editTenderStore/setAdditionalFieldsTenderNew', { values: [] })
    },

    /**
     * Оновлення стану кроку
     */
    $_updateStepState(newStepNumber) {
      this.currentStep = newStepNumber
      this.createRules()
    },

    /**
     * Оновлення роутера та інформації
     */
    async $_updateRouterAndInfo(tender, newStepNumber, isNewTender) {
      const id = tender?.tenderId ? { id: tender.tenderId } : {}

      if (tender?.tenderId) {
        this.checkYouControl(isNewTender)
      }

      this.$router.replace({
        query: { ...this.$route.query, step: newStepNumber, ...id }
      }, () => {}, () => {}, { force: true })
      
      this.info = { ...this.info, step: newStepNumber }
      
      this.mixin_originTender = await this.removeTypename(this.$_.cloneDeep(this.tender)) || this.mixin_newTenderTemplate
    },

    /**
     * Створення Promise для збереження змін
     */
    $_createSavePromise(hasChange, isError, isNewTender) {
      if (hasChange || isError) {
        return this.$_saveTenderChanges(isNewTender, isError)
      }
      return Promise.resolve(this.tender)
    },
    async checkChangeControlProps(newStepNumber) {
      if (this.notice) {
        return true
      }

      const { biddingTypeId: newTypeId, criteryCard: newCriteryCard } = this.mixin_formData || {}
      const { biddingTypeId: oldTypeId, criteryCard: oldCriteryCard, lotGroups = [], lots = [], biddingType = {}, old_card = {}, prolongRuleCode } = this.mixin_originTender || {}

      if (newTypeId !== oldTypeId) {
        const newBiddingType = this.tender.biddingType || {}
        const notAllowed = []
        const criteryCardChanged = newCriteryCard !== oldCriteryCard

        if (lotGroups?.length && newBiddingType.biddingTypeId && !newBiddingType.groupedLotsEnabled) {
          notAllowed.push({dataQa: 'grouped-lots-enabled', label: this.$t('Validate.AlertConvertGroupLots')})
        }

        if ((!newBiddingType.initialRateAvailable || newBiddingType.isMultistage) && lots.some(lot => lot.startAmount)) {
          notAllowed.push({dataQa: 'initial-rate-available', label: this.$t('Tenders.BidType.initialRateAvailable')})
        }
        if ((!newBiddingType.bidStepAvailable || newBiddingType.isMultistage) && lots.some(lot => lot.bidStep)) {
          notAllowed.push({dataQa: 'bid-step-available', label: this.$t('Tenders.BidType.bidStepAvailable')})
        }
        if (!newBiddingType.reducedPriceAvailable && prolongRuleCode) {
          notAllowed.push({dataQa: 'prolongation-rule-available', label: this.$t('Tenders.BidType.prolongationRuleAvailable')})
        }
        if (!newBiddingType.reducedPriceAvailable && biddingType.reducedPriceAvailable && old_card.useReducedPrice) {
          notAllowed.push({dataQa: 'reduced-price-available', label: this.$t('Tenders.BidType.reducedPriceAvailable')})
        }
        if (!newBiddingType.analogAvailable && biddingType.analogAvailable && (old_card.criterias || []).some(el => el.useInAnalogNaming)) {
          notAllowed.push({dataQa: 'analog-available', label: this.$t('Tenders.BidType.analogAvailable')})
        }

        if (notAllowed.length || criteryCardChanged) {
          let html = notAllowed.length
            ? `<p>${this.$t('Tenders.ThisBiddingTypeDoesNotProvide')}:</p><ul style="padding: 0 0 10px 25px " class="bid-type-deleting">${notAllowed.map(el => `<li class="bid-type-deleting__item" data-qa="${el.dataQa}">${el.label}</li>`).join('')}</ul><p>${this.$t('Tenders.TheDataWillBeDeleted')}</p>`
            : ''
          if (criteryCardChanged) {
            html += (html ? `<br/><b>${this.$t('Common.PleaseNote')}!</b>` : '') + `<p>${this.$t('Tenders.criteriaMapReplaced')}</p>`
          }
          const notifyKey = this.$_createGuid()
          this.notice = this.$notice.warning({
            id: notifyKey,
            title: this.$t('Tenders.TenderParametersChanged'),
            message: html,
            dataQa: 'change-params',
            dangerouslyUseHTMLString: true,
            showClose: true,
            onClick: () => {
              this.notice = null
              this.changeSteps(newStepNumber)
              this.$set(this.mixin_originTender, 'biddingTypeId', newTypeId)
            },
            onClose: () => {
              this.notice = null
            },
            closeText: this.$t('Tenders.RejectChanges'),
            clickText: this.$t('Tenders.ConfirmChanges'),
            progress: true,
            duration: 10,
          })
          return true
        }
      }
      return false
    },
    /**
     * Головний метод зміни кроку
     * newStepNumber - новий шаг
     * prepare - підготовка даних
     */
    async changeSteps(newStepNumber, prepare) {

      const changedFields = await this.getChangeProps()
      const hasChanges = Array.isArray(changedFields) ? changedFields.length > 0 : !!changedFields

      const { isError } = await this.$_validateBeforeNextStep(newStepNumber)

      if (!this.$_validateStepNumber(newStepNumber)) {
        return
      }

      try {
        if (!prepare) {
          const shouldStop = await this.checkChangeControlProps(newStepNumber)
          if (shouldStop) {
            this.$spinner.close()
            return
          }
        }

        if (isError) {
          return
        }
        this.$spinner.show()

        const isStepNext = !prepare && newStepNumber > this.currentStep && newStepNumber !== this.currentStep

        if (isStepNext && this.componentMain.needChange) {
          if (!this.$_checkStepAccess(newStepNumber, prepare)) {
            return
          }
        }

        const isNewTender = !this.mixin_tenderId

        const tenderPromise = isStepNext && this.componentMain.needChange
          ? this.$_createSavePromise(hasChanges, isError, isNewTender)
          : Promise.resolve(this.tender)

        const tender = await tenderPromise
        await this.$_applyStepChanges(tender, newStepNumber, isStepNext, isNewTender)
      } catch (error) {
        throw this.$t('Common.ErrorTitle')
      } finally {
        this.$spinner.close()
        this.accesNextStep = false
      }
    },
    async getTenderInfo() {
      this.tenderInfo = {}
      tender_api.getTender(this.mixin_tenderId)
        .then(res => {
          if (!res) {
            this.$router.push({name: 'page-error', params: { status_code: 404, descript: 'tenderActions'}})
            return
          }
          res.biddingTypeId = res.biddingType?.biddingTypeId
          this.tenderInfo = res
        })
        .catch(res => this.$log_error(res))
    },
    /**
     * Выход на главную
     */
    gotoTendersPage() {
      // test-value: добавить проверку что данные изменились
      //this.$router.push({ name: 'tenders', params: {org: this.$route.params.org}, query: {}})
      this.$router.push({ name: 'tenderitem', params: {id: this.mixin_tenderId, org: this.$route.params.org, }, query: {}})
    },
    createRules: debounce(async function (startvalidate) {
      if (this.steps?.length) {
        const rules = getCombinedRules(this, this.currentStepProps.rules)
        this.$set(this, 'stepRules', rules)
        this.clearValidate()
        if (startvalidate) {
          this.$nextTick(() => {
            this.validateForm()
          })
        }
      }
    }, 250),
    /**
     * Формируем список шагов
     */
    createSteps: debounce(async function () {
      const flou = `newDesignDefault_${this.$route.query?.flou || 'default'}`
      if (!flouProps[flou]) {
        return
      }
      const steps = flouProps[flou](this.stepProps)
        .map(i => ({
          ...i,
          label: this.$t(`Tenders.CreateStep.${i.text}.Name`),
          hint: this.$t(`Tenders.${i.text}`),
        }))
        .filter(i => i.visible)
        .sort((a, b) => a.order - b.order)

      this.$set(this, 'steps', steps)
      this.info = {...this.info, steps: steps.map(i => i.text)}
    }, 250),
    async getEditingTender(tenderId) {
      let item
      await tender_api.getEditingTender(tenderId)
        .then(async res => {
          item = res?.data?.editingTender
          this.$_initializeLotGroups(item, true)
          if (item?.lots?.length) {
            item.lots = item.lots.sort((a, b) => a.lotNumber - b.lotNumber)
          }
          const tenderPublishedSchedule = item?.tenderPublishedSchedule
          item = await this.mixin_checkTenderBySettings(item)
          if (!item) {
            this.$log_error(`Ошибка получения тендера. ID:${tenderId}`)
            this.$router.push({ name: 'tenderitem', params: { id: tenderId, org: this.$route.params.org }})
          } else {
            item.biddingTypeId = item?.biddingType?.biddingTypeId
            item.tenderPublishedSchedule = tenderPublishedSchedule
          }
          this.tender = item
        })
        .catch(res => this.$log_error(res))
      return item
    },
    /**
     * Подготавливаем данные страницы
     */
    async prepareDate() {
      const currentStep = +this.$route.query?.step || 1
      if (!this.mixin_tenderId && (currentStep !== 1 || this.$route.name !== 'newTender')) {
        window.location.href = this.$router.resolve(
          {
            name: 'newTender',
            query: {flou: this.$route.query.flou || 'default', step: 1 }
          }
        ).href
        return
      }
      if (this.mixin_tenderId && this.$route.name !== 'editTender') {
        window.location.href = this.$router.resolve(
          {
            name: 'editTender',
            query: {...this.$route.query }
          }
        ).href
        return
      }
      /** если есть ключ тендера при входе, значит это редактирование */
      if (this.mixin_tenderId) {
        await this.getEditingTender(this.mixin_tenderId)

        if (!this.tender?.tenderId) {
          this.$router.push({ name: 'page-error', params: { status_code: 404, descript: 'NewTender' }})
          return
        }
        /*await this.$store.dispatch('agreeLatest', [+this.mixin_tenderId]) Вылет на первом шаге. ОЧень может быть, что нужно только на последнем
          .then(res => {
            if (res?.length) {
              this.$_setAgreementValues(res)
            }
          })*/
        if (this.tender?.tenderStatusId !== 1 || this.tender?.tenderPublishedSchedule?.isScheduled || this.tender?.hasRoute) {
          this.$router.push({ name: 'tenderitem', params: { id: this.mixin_tenderId, org: this.$route.params.org }})
          return
        }
      } else {
        this.$set(this, 'tender', this.mixin_newTenderTemplate)
      }

      let result = {
        step: currentStep,
        steps: this.steps.map(el => el.text),
        default: this.mixin_newTenderTemplate
      }
      this.changeSteps(result.step, true)
        .then(() => {
          this.info = result
          this.flou = `newDesignDefault_${this.$route.query?.flou || 'default'}`
          this.loading.initial = false

          /*if (!this.tender.tenderId) {
            this.$nextTick(async () => {
              this.minProposalsDate =  await this.mixin_getMinProposalsDate()
              this.tender.tenderPeriodTo = this.mixin_tenderDateMin.dateSharp
            }
          }*/

          this.clearValidate()
        })
    },
    blockSteps(state) {
      this.loading.blockSteps = state
    },
    backStep(stepName) {
      if (!stepName) {
        this.changeSteps(this.currentStep - 1)
        return
      }

      let stepComponent = ''
      switch (stepName) {
      case 'NotPriceCriteria' : {
        stepComponent = 'TenderCriteria'
        break
      }
      case 'Documents' : {
        stepComponent = 'TenderCommercialDocumentAndOffer'
        break
      }
      case 'AddLots' : {
        stepComponent = 'TenderLots'
        break
      }
      case 'Members' : {
        stepComponent = 'TenderMembers'
        break
      }
      default: {
        break
      }
      }
      const stepIndex = this.steps.findIndex(i => i.component === stepComponent)
      if (stepIndex === -1) {
        this.changeSteps(this.currentStep - 1)
      } else {
        this.changeSteps(stepIndex + 1)
      }
    }
  },
  computed: {
    ...mapGetters({
      tenderFlouSteps: 'editTenderStore/tenderFlouSteps',
      fieldErrors: 'editTenderStore/fieldErrors',
      tenderFlouCurrentStep: 'editTenderStore/tenderFlouCurrentStep',
      currentStepProps: 'editTenderStore/tenderFlouCurrentStepProps'
    }),
    isTwoColumn() {
      return this.steps[this.currentStep - 1] && this.steps[this.currentStep - 1].componentInfo
    },
    steps: {
      get() {
        return this.tenderFlouSteps
      },
      set(newValue) {
        this.$store.dispatch('editTenderStore/setTenderFlouSteps', {values: newValue})
      }
    },
    currentStep: {
      get() {
        return this.tenderFlouCurrentStep
      },
      set(newValue) {
        this.$store.dispatch('editTenderStore/setTenderFlouCurrentStep', {value: newValue})
      }
    },
    componentMain() {
      const isTenderCheck = this.currentStepProps.component === 'TenderCheck'
      if (!this.currentStepProps || (isTenderCheck && !this.tenderInfo)) {
        return null
      }
      const result = {
        component: this.currentStepProps.component,
        needChange: this.currentStepProps.component !== 'YoucontrolStep',
        options: {
          loading: this.loading.save,
          tender: this.tender,
          rules: this.stepRules
        },
        handlers: {
          changeRules: (e) => { this.changeRules(e) },
          clearValidate: (e) => { this.clearValidate(e) },
          startValidate: (e) => { this.validateForm(e) },
          backStep: (e) => { this.backStep(e) },
          blockSteps: (e) => { this.blockSteps(e) },
          nextStep: () => { this.changeSteps(this.currentStep + 1) },
        }
      }
      if (this.currentStepProps.component === 'TenderCheck') {
        result.options.tenderInfo = this.tenderInfo
        //result.handlers['update:tender'] = (e) => { this.tenderInfo = e }
        result.handlers['update:tender'] = (e) => { 
          this.tender = e
        }
        result.handlers['update:rules'] = (e) => { this.stepRules = e }
      } else {
        result.handlers['update:tender'] = (e) => { 
          this.tender = e
        }
        result.handlers['update:rules'] = (e) => { this.stepRules = e }
      }
      return result
    },
    componentInfo() {
      const isTenderCheck = this.currentStepProps.component === 'TenderCheck'
      if (!this.currentStepProps || (isTenderCheck && !this.tenderInfo)) {
        return null
      }
      const result = {
        component: this.currentStepProps.componentInfo,
        options: {
          loading: this.loading.save,
          mini: this.mini,
          can_edit: this.canEdit,
          tender: this.currentStepProps.component === 'TenderCheck' ? this.tenderInfo : this.tender,
          tenderId: this.tender?.tenderId
        },
        handlers: {
          changeRules: (e) => { this.changeRules(e) },
          clearValidate: (e) => { this.clearValidate(e) },
          startValidate: (e) => { this.validateForm(e) },
          'update:mini': (e) => { this.mini = e },
          'update:can_edit': (e) => { this.canEdit = e },
        }
      }
      if (this.currentStepProps.component === 'TenderCheck') {
        result.handlers['update:tender'] = (e) => { this.tenderInfo = e }
      } else {
        result.handlers['update:tender'] = (e) => {
          this.tender = e
        }
      }

      return result
    },
    breadcrumbs() {
      const result = [
        {
          index: 0,
          text: this.$t('Tenders.Tenders'),
          maxLength: 100,
          to: { name: 'tenders', params: {org: this.$route.params.org}}
        }
      ]
      if (this.loading.initial) {
        result.push({
          maxLength: 100,
          text: this.$t('Common.Loading'),
        })
        return result
      }
      if (this.mixin_tenderId && this.tender?.tenderSubject) {
        result.push({
          index: 1,
          maxLength: 100,
          text: this.tender?.tenderSubject,
          action: () =>  this.gotoTendersPage()
        })
      }
      result.push({
        maxLength: 100,
        text: !this.mixin_tenderId ? this.$t('Tenders.TenderCreation') : this.$t(`Tenders.${this.currentStepProps.text}`),
      })
      return result
    },
    stepProps() {
      return {
        flou: this.flou,
        isPlan: false,
        isAuctioFromFrame: this.tender?.biddingType?.isFrameAuction,
        isAuctionWithoutPublication: this.tender?.biddingType?.withoutPublication,
        createdByExternalApi: this.tender?.createdByExternalApi,
        useCriteriaCards: this.$can('use', 'useCriteriaCards')
      }
    },
  },
  watch: {
    stepProps: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.createSteps()
        }
      }
    },
    steps: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.createRules()
        }
      }
    },
    currentStepProps: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (newValue?.component !== oldValue?.component && newValue?.component === 'TenderCheck') {
          this.getTenderInfo()
        }
      }
    },
  },
  async created() {
    this.$store.dispatch('editTenderStore/clearAdditionalFields')
    this.$root.$on('exitConfirmationApply', this.ignoreChange)
    this.$root.$on('createRuleAdditionalFields', this.createAdditionalFieldRule)
    this.$root.$on('setAccessNextStep', this.setAccessNextStep)
    await this.prepareDate()
  },
  beforeDestroy() {
    this.$set(this, 'steps', [])
    this.$root.$off('exitConfirmationApply', this.ignoreChange)
    this.$root.$off('createRuleAdditionalFields', this.createAdditionalFieldRule)
    this.$root.$off('setAccessNextStep', this.setAccessNextStep)
  },
  components: {
    TenderLots,
    Breadcrumbs,
    TenderSteps,
    TenderCheck,
    TenderMembers,
    TenderCriteria,
    YoucontrolStep,
    TenderInfoPanel,
    CreateItemFooter,
    TenderTopActions,
    TenderInformation,
    TenderMembersInfo,
    TenderCommercialDocumentAndOffer,
  },
}
</script>
<style scoped lang="scss">
.createTender {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: calc(100% - 72px) auto;
  height: 100vh;
  &.two-column {
    transition: all 0.25s;
    grid-template-columns: 1fr auto;
    &.is-min {
      grid-template-columns: 1fr 54px;
    }
  }
  &_left {
    overflow: auto;
    display: grid;
    grid-template-rows: 44px 1fr;
    hyphens: auto;
  }
  &_right {
    height: 100%;
  }
  &_breadcrumbs {
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--main__green_locked);
  }
  &_title {
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    text-align: left;
    padding: 0 0 0 10px;
  }
  &_description {
    margin-top: 8px;
    line-height: 20px;
    font-size: 16px;
    text-align: left;
    padding: 0 0 0 10px;
  }
  &_breadcrumbs,
  &_content {
    padding-left: 30px;
    padding-right: 30px;
  }
  &_content {
    max-height: 100%;
    overflow: auto;
    padding-top: 10px;
    overflow: auto;
    margin: 0 auto;
  }
}
</style>
